import { IPriceBookCompanyItem } from 'src/common/interfaces/price-book.interfaces';
import i18n from 'i18next';
import translations from 'src/internationalisation/translation-map.json';

export const headings = ['', 'name', 'priceBookName', 'costCodesId', 'vendor'];

const headerTranslationsMap: { [key: string]: string } = {
  name: i18n.t(translations.name),
  costCodesId: i18n.t(translations.priceBook_itemCode),
  vendor: i18n.t(translations.priceBook_vendor),
  priceBookName: i18n.t(translations.priceBook),
};

export const filterDataRows = (
  dataRows: IPriceBookCompanyItem[],
  filters: IPriceBookCompanyItem | Record<string, never>,
) =>
  dataRows.filter((row) =>
    (Object.keys(filters) as (keyof typeof filters)[]).every((key) => {
      return filters[key] === ''
        ? true
        : row[key]
            ?.toString()
            .toLowerCase()
            .includes((filters[key] || '').toString().toLowerCase());
    }),
  );

export const dataHeaders = (
  dataRowsKeys: string[],
  filters: IPriceBookCompanyItem | Record<string, never>,
  setFilters: (args: IPriceBookCompanyItem) => void,
) => {
  const dataHeaderCells = dataRowsKeys.map((key) => {
    const keyTyped = key as keyof IPriceBookCompanyItem;
    const prettifyHeaderValue = headerTranslationsMap?.[keyTyped] || '';
    return {
      key,
      value: prettifyHeaderValue,
    };
  });
  const dataFilterCells = dataRowsKeys.map((key) => {
    if (!key) {
      return {};
    }
    const keyTyped = key as keyof IPriceBookCompanyItem;
    const filterValue = Object.keys(filters).includes(key) ? filters[keyTyped] : '';
    return {
      key,
      value: filterValue,
      type: 'Input',
      placeholder: 'Filter',
      onChange: (ev: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) =>
        setFilters({
          ...filters,
          [keyTyped]: ev.target.value,
        } as IPriceBookCompanyItem),
    };
  });
  return {
    dataHeaderCells,
    dataFilterCells,
  };
};
